class MFRSectionCurve {
    constructor( element, position, offset  ) {
        this.$element = $( element );
        this.position = position;
        this.offset = ( Boolean(this.$element.data( "section-curve-on-mobile" )) && $( window ).width() <= 639 ) ? "10px" : offset;
        this.maxSpacing = 50;
        this.maxBorderRadius = 30;
        this.bgColor = this.$element.data( "section-curve-bg" ) == "" || !this.$element.data( "section-curve-bg" ) ? "transparent" : this.$element.data( "section-curve-bg" );
        this.topTriggers = {
            start: "top 80%",
            end: "top 10%",
        }
        this.bottomTriggers = {
            start: "bottom 80%",
            end: "bottom 10%",
        }

        this.selectors = {
            wrapper: ".shopify-section"
        }
        
        this.init();
    }

    init() {
        this.$wrapper = this.$element.closest( this.selectors.wrapper );
        // setTimeout( () => this.setInitialState(),1000 );
        this.setInitialState();
    }

    setInitialState() {
        const backgroundColor = this.generateBG();
        gsap.set( this.$element, {
            margin: "0 auto",
            scaleX: .93
        } );
        gsap.set( this.$wrapper, {
            background: backgroundColor
        } );
        
        if( this.position == "top" ) {
            this.$wrapper.addClass("curved-section--top");
            gsap.to( this.$wrapper, {
                marginTop: `-${ this.offset }`,
                zIndex: 1,
                position: "relative"
            } )
            gsap.set( this.$element, {
                borderTopLeftRadius: this.maxBorderRadius,
                borderTopRightRadius: this.maxBorderRadius,
                overflow: "hidden",
                opacity: "0.9999999"
            } );
            gsap.to( this.$element, {
                borderTopLeftRadius: 0,
                borderTopRightRadius: 0,
                scaleX: 1,
                scrollTrigger: {
                    trigger: this.$element,
                    scrub: true,
                    ...this.topTriggers
                }
            } )
        }
        if( this.position == "bottom" ) {
            this.$wrapper.addClass("curved-section--bottom");
            gsap.to( this.$wrapper, {
                marginBottom: `-${ this.offset }`,
                zIndex: 1,
                position: "relative"
            } )
            gsap.set( this.$element, {
                overflow: "hidden",
                borderBottomLeftRadius: 0,
                borderBottomRightRadius: 0,
                scaleX: 1
            } );
            gsap.to( this.$element, {
                borderBottomLeftRadius: this.maxBorderRadius,
                borderBottomRightRadius: this.maxBorderRadius,
                opacity: "0.9999999",
                scaleX: 0.93,
                scrollTrigger: {
                    trigger: this.$element,
                    scrub: true,
                    ...this.bottomTriggers
                }
            } )
        }

        if( ScrollTrigger && ScrollTrigger.refresh )
            ScrollTrigger.refresh();
    }

    generateBG() {
        if ( this.$element.data( "section-curve-top") && this.$element.data( "section-curve-bottom" ) )
            return `linear-gradient( transparent, ${ this.bgColor } ${ this.offset }, ${ this.bgColor } calc(100% - ${ this.offset }), transparent )`
        else if ( this.$element.data( "section-curve-bottom" ) )
            return `linear-gradient( transparent 5px, ${ this.bgColor } ${ this.offset }, ${ this.bgColor } calc(100% - ${ this.offset }), transparent )`;
        else if( this.$element.data( "section-curve-top") )
            // return `linear-gradient(transparent, ${ this.bgColor } ${ this.offset }, ${ this.bgColor } calc(100% - ${ this.offset }),  transparent 5px)`;
            return `linear-gradient(transparent, ${ this.bgColor } ${ this.offset }, ${ this.bgColor } calc(100%),  transparent 5px)`;
    }
}

class MFRSectionCurveTop {
    constructor( i, e ) {
        const mfrSectionCurve = new MFRSectionCurve( e, "top", $( e ).data( "section-curve-top" ) );
    }
}

class MFRSectionCurveBottom {
    constructor( i, e ) {
        const mfrSectionCurve = new MFRSectionCurve( e, "bottom", $( e ).data( "section-curve-bottom" ) );
    }
}